export const smesshyVersion = "1754";
